module.exports = __webpack_public_path__ + "assets/img/default_player.png?76e0b52e08c20735e0c18b7e14e122c0";